export default __webpack_public_path__ + "static/media/Ida_Marie_Collins_Solid_Truth_AHV_In_Moms_We_Trust.50331160.jpg";